import classNames from 'classnames';
import { CSSProperties, FC, ReactNode } from 'react';

const Heading: FC<IHeadingProps> = ({
  children,
  level,
  color,
  className,
  style,
  id,
  title,
}) => {
  const Tag: any = `h${level}`;

  return (
    <Tag
      className={classNames('heading', `heading_level-${level}`, className)}
      id={id}
      style={{ color: `${color}`, ...style }}
      title={title}
    >
      {children}
    </Tag>
  );
};

interface IHeadingProps {
  children: ReactNode;
  className?: string;
  color?: string;
  level: number;
  style?: CSSProperties;
  id?: string;
  title?: string;
}

export default Heading;
